package it.maicol07.gamerlogue.ui.navigation.rootTree

import androidx.navigation3.runtime.NavKey
import io.github.fopwoc.nav3ksp.NavTree
import it.maicol07.gamerlogue.services.ExternalService
import it.maicol07.gamerlogue.ui.views.discover.DiscoverSection
import it.maicol07.gamerlogue.ui.views.library.GameLibraryStatus
import it.maicol07.gamerlogue.ui.views.list.GameListPreset
import it.maicol07.gamerlogue.ui.views.list.GamePick
import it.maicol07.gamerlogue.ui.views.settings.categories.ImportMode
import it.maicol07.gamerlogue.ui.views.settings.categories.ServiceSyncAction
import it.maicol07.gamerlogue.ui.views.social.ConnectionsKind
import kotlin.Int
import kotlin.String
import kotlinx.serialization.Serializable

public object RootNavTree : NavTree {
  @Serializable
  public data class UserListDetail(
    public val listId: String,
  ) : NavKey

  @Serializable
  public data class UserConnections(
    public val userId: String,
    public val kind: ConnectionsKind,
  ) : NavKey

  @Serializable
  public data object BlockedUsers : NavKey

  @Serializable
  public data object Notifications : NavKey

  @Serializable
  public data object ActivityFeed : NavKey

  @Serializable
  public data object EventList : NavKey

  @Serializable
  public data object Calendar : NavKey

  @Serializable
  public data class ServiceSync(
    public val service: ExternalService,
    public val action: ServiceSyncAction,
  ) : NavKey

  @Serializable
  public data object ServerSettings : NavKey

  @Serializable
  public data object LinkedServices : NavKey

  @Serializable
  public data class LibraryImportPreview(
    public val service: ExternalService,
    public val mode: ImportMode,
  ) : NavKey

  @Serializable
  public data object Appearance : NavKey

  @Serializable
  public data object Settings : NavKey

  @Serializable
  public data object Profile : NavKey

  @Serializable
  public data class UserProfile(
    public val userId: String,
  ) : NavKey

  @Serializable
  public data object Login : NavKey

  @Serializable
  public data class ReviewDetail(
    public val entryId: String,
    public val userId: String?,
  ) : NavKey

  @Serializable
  public data class ReviewEditor(
    public val entryId: String,
  ) : NavKey

  @Serializable
  public data object Library : NavKey

  @Serializable
  public data class GameList(
    public val section: DiscoverSection?,
    public val eventId: Int?,
    public val eventName: String?,
    public val preset: GameListPreset?,
    public val libraryStatus: GameLibraryStatus?,
    public val libraryUserId: String?,
    public val pick: GamePick?,
  ) : NavKey

  @Serializable
  public data object Discover : NavKey

  @Serializable
  public data class GameDetail(
    public val gameId: Int,
    public val coverImageId: String?,
    public val gameName: String?,
  ) : NavKey

  @Serializable
  public data class GameReviews(
    public val gameId: Int,
  ) : NavKey
}
